import { GET_ARITY_OPT_IN } from '../actions/arityActions';

const initialState = {
    detailIsRefreshing: false,
    optIn: undefined
};

export function arity(state = initialState, action)
{
    switch (action.type)
    {
        case GET_ARITY_OPT_IN.pending:
        {
            return {
                ...state
                , optin: undefined
                , detailIsRefreshing: true
            };
        }
        case GET_ARITY_OPT_IN.fulfilled:
        {
            return {
                ...state
                , optin: action.payload
                , lastError: {}
                , detailIsRefreshing: false
            };
        }
        case GET_ARITY_OPT_IN.rejected:
        {
            return {
                ...state
                , optin: undefined
                , lastError: action.payload
                , detailIsRefreshing: false
            };
        }

        default:
        {
            return state;
        }
    }
}
